import type { LDContext } from 'launchdarkly-react-client-sdk';
import type { UserDetails } from 'src/types/auth';

export function getLaunchDarklyContext(
	userDetails: UserDetails | null,
): LDContext | undefined {
	if (!userDetails?.property_manager_id) return undefined;
	return {
		kind: 'multi',
		user: {
			key: String(userDetails.property_manager_id),
			name: `${userDetails.first_name} ${userDetails.last_name}`,
			email: userDetails.email,
			role: userDetails.property_manager_type as string | undefined,
		},
		...(userDetails.partner?.partner_id
			? {
					partner: {
						key: String(userDetails.partner.partner_id),
						name: userDetails.partner.label as string | undefined,
						email: userDetails.partner.email as string | undefined,
					},
				}
			: {}),
	};
}
